import ItemView from './PayrollItem.js';
import ListEditablesView from 'commons/views/ListEditables.js';
import modal from 'helpers/modal';
import PayrollItemIntegration from 'newModels/payroll-item-integration.js';
import template from
    '../../../../templates/settings/integrations/quickbooks/PayrollItems.ejs';
import PayrollItemSelectionModal from
    'employer/views/PayrollItemSelectionModal.js';

module.exports = ListEditablesView.extend({
    modelViews: [],
    modalView: null,

    events: function() {
        var parentEvents = _.isFunction(ListEditablesView.prototype.events) ?
            ListEditablesView.prototype.events() :
            ListEditablesView.prototype.events;

        return _.extend(_.clone(parentEvents), {
            'click .js-add-items': 'showSelectModal',
            'click .js-show-all-items': 'addAllItems',
            'click .js-hide-unmapped-items': 'destroyUnmappedItems',
        });
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            template: template,
            Model: PayrollItemIntegration,
            ModelView: ItemView,
            qbAccounts: [],
            mappableItems: null,
            defaults: null
        });
        this.options.templateExtra = {qbAccounts: this.options.qbAccounts};

        this.unmappedItems = this.options.mappableItems.clone();
        this.updateItemAvailability();

        this.payrollItemsModal = new PayrollItemSelectionModal({
            collection: this.unmappedItems
        });

        return ListEditablesView.prototype.initialize.apply(
            this, [this.options]
        );
    },

    bindHandlers: function() {
        this.payrollItemsModal.on('select', this.addItems, this);
        this.collection.on(
            'add remove reset', this.updateItemAvailability, this
        );
        this.collection.on('remove', this.removeModelView, this);
        return ListEditablesView.prototype.bindHandlers.apply(this, arguments);
    },

    unbindHandlers: function() {
        this.payrollItemsModal.off(null, null, this);
        return ListEditablesView.prototype.bindHandlers.apply(this, arguments);
    },

    renderModels: function() {
        if (!this.options.ModelView) {
            return this;
        }

        if (!this.collection) {
            return this;
        }

        const payrollItemIds = _(this.collection.map(
            model => model.get('payrollItemId')
        )).uniq();

        let payrollItems = app.payrollItems.filter(model => {
            if (payrollItemIds.includes(model.id)) {
                return model;
            }
        });

        this.removeModelViews();
        // loop through payrollItemIds because that list is sorted
        payrollItemIds.forEach(itemId => {
            const item = payrollItems.find(item => item.id === itemId);
            if (!item) {
                return;
            }

            let employeeIntegration = null;
            let employerIntegration = null;

            if (this.isEmployeePayable(item)) {
                employeeIntegration = this.collection.find(model => {
                    return (
                        model.get('affects') === 'employee' &&
                        model.get('payrollItemId') === item.id
                    );
                }) || new PayrollItemIntegration({
                    companyId: app.company.id,
                    payrollItemId: item.id,
                    integrationId: this.options.integration.id,
                    affects: 'employee',
                    remoteId: null,
                    remoteName: null,
                    syncedAt: null
                });
                if (employeeIntegration.isNew()) {
                    this.collection.add(employeeIntegration, {silent: true});
                }
            }

            if (this.isEmployerPayable(item)) {
                employerIntegration = this.collection.find(model => {
                    return (
                        model.get('affects') !== 'employee' &&
                        model.get('payrollItemId') === item.id
                    );
                }) || new PayrollItemIntegration({
                    companyId: app.company.id,
                    payrollItemId: item.id,
                    integrationId: this.options.integration.id,
                    // 20210913 PPKAN-256
                    // hard-coded logic, again, for our dear "Employer HRDF Levy (Custom)"
                    affects: item.get('subtype') === 'hrdf' ?
                        'hrdf' : item.get('type'),
                    remoteId: null,
                    remoteName: null,
                    syncedAt: null
                });
                if (employerIntegration.isNew()) {
                    this.collection.add(employerIntegration, {silent: true});
                }
            }

            this.renderModel(item, employeeIntegration, employerIntegration);
        });

        return this;
    },

    renderModel: function(model, employeeIntegration, employerIntegration) {
        const view = new this.options.ModelView({
            model,
            employeeIntegration,
            employerIntegration,
            qbAccounts: this.options.qbAccounts
        });
        this.$('.js-model-views').append(view.$el);
        this.modelViews.push(view);
        return this;
    },

    save: function(ev) {
        ListEditablesView.prototype.save.apply(this, [ev]).then(function() {
            modal.showAlertSuccess('Mappings have been saved');
        });
        return false;
    },

    showSelectModal: function(ev) {
        ev.preventDefault();
        this.payrollItemsModal.show();
    },

    addAllItems: function(ev) {
        ev.preventDefault();
        this.addItems(this.unmappedItems);
    },

    // Destroy all unmapped items, except the defaults
    destroyUnmappedItems: function(ev) {
        ev.preventDefault();
        let unmapped = this.collection.filter(model => {
            const isDefault = !!this.options.defaults.find(
                m => m.id === model.get('payrollItemId')
            );
            return !isDefault && !model.get('remoteId');
        });
        unmapped.forEach(model => this.collection.remove(model));
    },

    updateItemAvailability: function() {
        this.unmappedItems.reset(
            this.options.mappableItems.clone().filter(model => {
                return !this.collection.find(itemIntegration => {
                    let itemId = itemIntegration.get('payrollItemId');
                    return (itemId === model.id);
                });
            })
        );
    },

    isEmployerPayable: function(payrollItem) {
        return ['mtd', 'socso', 'epf', 'zakat', 'eis', 'hrdf', 'cp38']
            .includes(payrollItem.get('type')) ||
            payrollItem.get('subtype') === 'hrdf';
    },

    isEmployeePayable: function(payrollItem) {
        return !this.isEmployerPayable(payrollItem) || payrollItem.get('isNet');
    },

    addItems: function(payrollItems) {
        payrollItems.forEach(payrollItem => {
            if (this.isEmployeePayable(payrollItem)) {
                this.collection.add({
                    companyId: app.company.id,
                    payrollItemId: payrollItem.id,
                    integrationId: this.options.integration.id,
                    affects: 'employee',
                    remoteId: null,
                    remoteName: null,
                    syncedAt: null
                }, {silent: true});
            }

            if (this.isEmployerPayable(payrollItem)) {
                this.collection.add({
                    companyId: app.company.id,
                    payrollItemId: payrollItem.id,
                    integrationId: this.options.integration.id,
                    // 20210913 PPKAN-256
                    // hard-coded logic, again, for our dear "Employer HRDF Levy (Custom)"
                    affects: payrollItem.get('subtype') === 'hrdf' ?
                        'hrdf' : payrollItem.get('type'),
                    remoteId: null,
                    remoteName: null,
                    syncedAt: null
                }, {silent: true});
            }
        });

        this.renderModels();
    },

    removeModelView: function(model) {
        let view = this.modelViews.find(
            v => v.model.id === model.get('payrollItemId')
        );
        if (!view) { return; }
        view.remove();
        view = null;
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/settings/integrations/quickbooks/PayrollItems.js